export default class DataGridStyleOptions {
    public Table: any[] = [];
    public Header: any[] = [];
    public Cell: any[] = [];
    public NavigationItem: any[] = [];
    public NavigationLink: any[] = [];
    public NavigationItemDisabled: any[] = [];
}
